import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Grid from '@mui/material/Grid'
import Table from '../../Components/common/tableWithBackEndPagination'
import Moment from 'moment'
import MenuItem from "@mui/material/MenuItem";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../Layout/Loader'
import TextField from '../common/TextField'
import { 
  actionTypes,itemTypes,AccountsItem,AttributesItem,CalenderItem,
  CommandItem,CouponItem,DashboardItem,DevicesItem,DriverItem,
  EcoDrivingItem,EventsItem,GeoFenceItem,ResourcesItem,ItemGroups,
  JobsItem,MaintenanceItem,NotificationItem,
  OrdersItem,PasswordsItem,POIItem,PositionItem,RolesItem,
  ReportTemplatesItem,SensorsItem,ServicesItem,SessionsItem,
  TrailersItem,UsersItem,VehiclesItem,LinkUnlinkItems,ExpenseTypeItem,ExpenseSubTypeItem,GarageItem,AreaItem
} from './actionLogsTypes'
import CustomDateRangePicker from '../common/DateRangePicker'
import moment from 'moment'
import Button from "../../Components/common/Button";
import ExportFile from '../common/ExportFile'
import { Close } from '@mui/icons-material'
import { InputAdornment } from '@mui/material'
import AsyncSelect from '../common/asyncSelect'


class showLogs extends Component {
  constructor () {
    super()
    this.state = {
        tableData: [],
        laoder:true,
        pageSize:20,
        page:1,
        itemSearch: 'all',
        subType:'',
        typeSelection:'',
        loader:true,
        searchActionLogs:"",
        fromDate:"",
        toDate:"",
        selectedDateTime:"",
    }
  }
 
  componentWillMount () {
    this.getActionLogs()
    this.getAllUsers()
  }

  getActionLogs = () => {
    const {
      page,
      pageSize,
      itemSearch,
      typeSelection,
      subType,
      fromDate,
      toDate,
      searchActionLogs,
      form,
      userId
    } = this.state;
  
    const params = new URLSearchParams();
  
    params.append("page", page);
    params.append("limit", pageSize);
  
    if (typeSelection) params.append("typeSelection", typeSelection);
    if (subType) params.append("type", subType);
    if (itemSearch) params.append("itemSearch", itemSearch);
    if(userId) params.append("userId",userId)
    if (fromDate && toDate) {
      params.append("from", fromDate);
      params.append("to", toDate);
    }
    if(searchActionLogs){
      params.append("search", searchActionLogs);
    }
  
    const url = `/api/actionlogs/allusers?${params.toString()}`;
  
    fetch(url,{
      method: "GET",
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
          response.json().then(res => {
            if(res.status ==='success'){ 
              if (res.data.data) {
                let udata = res.data.data
                let logs = udata.map(u => {
                  if (u.actionTime) {
                    return {
                      ...u,
                      actionTime: this.props.logInUser.twelveHourFormat
                        ? Moment(u.actionTime).format('YYYY-MM-DD hh:mm A')
                        : Moment(u.actionTime).format('YYYY-MM-DD HH:mm'),
                         action: actionTypes.find(action => action.key === u.action),
                         actionDetails: `${u.itemLabel} ${u.itemType}`
                    }
                  } else {
                    return { ...u }
                  }
                })
                this.setState({
                    tableData:logs,
                    pagData: res.data,
                    loader:false
            
                })
              }
            }
            else if(res?.statusCode === '440'){
              window.location.replace('/login')
            }
            else if(res.statusCode){
              var err = res?.message.split(':')
              err[1] =err[1].replace(')', "")
                toast.error(this.props.translate(err[1]))
              this.setState({loader:false})
              // window.location.replace('/users')
            }
            else {
              throw response
            }
          })
        })
        .catch(e => {
          console.log('e =',e)
        //   this.props.dispatch(toast.error({
        //   message: 'somethingWentWrong',
        //   autoDismiss: 5
        // }))
      })
  }

  handleChangeRowsPerPage = value => {
    this.setState( {page:1, pageSize: value}, () => this.getActionLogs()
    )
  }

  handleChangePage = value => {
    this.setState( {page: value},() => this.getActionLogs())
  }

  setPagination = user => {
    if (this.state.tableData.length) {
      let nUser = { ...user }
      let lastPage = nUser.total / this.state.pageSize
      let IsFloate = this.checkFloteNumber(lastPage)
      delete nUser.data
      nUser.pageSize = this.state.pageSize
      nUser.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage
      return nUser
    }
    return {}
  }

  checkFloteNumber (n) {
    return Number(n) === n && n % 1 !== 0
  }

  handleChangeFilter = (event) => {    
      if(event){
        this.setState({subType:'',pageSize:20,page:1 })
      }  
      let typeSelection = ''
      if(event.target.value ===1){
        AccountsItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===21){
        AttributesItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===31){
        CalenderItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===41){
        CommandItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===51){
        CouponItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===61){
        DashboardItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===71){
        DevicesItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===91){
        DriverItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===101){
        EcoDrivingItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===111){
        EventsItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===121){
        GeoFenceItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===131){
        ResourcesItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===141){
        ItemGroups.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===151){
        JobsItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===161){
        MaintenanceItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===171){
        NotificationItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===181){
        OrdersItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===191){
        PasswordsItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===201){
        POIItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===211){
        PositionItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===231){
        RolesItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===241){
        ReportTemplatesItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===251){
        SensorsItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===261){
        ServicesItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===271){
        SessionsItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===281){
        TrailersItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===291){
        UsersItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===311){
        VehiclesItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===321){
        LinkUnlinkItems.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===501){
        GarageItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===526){
        ExpenseTypeItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===541){
        ExpenseSubTypeItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else if(event.target.value ===551){
        AreaItem.map(i => {
          typeSelection += '&type=' + i.key
        })
      }
      else{
        typeSelection =''
      }
      this.setState({itemSearch:event.target.value, typeSelection:typeSelection})
  }
  handleChangeSubType = (event) => {
      this.setState({subType: event.target.value,typeSelection:'',pageSize:20,page:1})
  }

  showDates = (e, date) => {
    const adjustedEndDate = date.endDate.clone().set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
    const duration = moment.duration(date.startDate.diff(adjustedEndDate));
    const hours = duration.asHours();
    let timezone = "Asia/Riyadh";
    if (
      this.props.ServerSetting &&
      this.props.ServerSetting.attributes &&
      this.props.ServerSetting.attributes.timezone
    ) {
      timezone = this.props.ServerSetting.attributes.timezone;
    }
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      timezone = this.props.logInUser.attributes.timezone;
    }
    moment.tz.setDefault(timezone);
    let formatedDate = {
      from: moment(date.startDate.format("YYYY-MM-DD HH:mm")).toISOString(),
      to: adjustedEndDate.toISOString(),
    };
    let timeFormat = "HH:mm";
    if (this.props.logInUser && this.props.logInUser.twelveHourFormat) {
      timeFormat = "hh:mm A";
    }
    this.setState({
      fromDate: formatedDate.from,
      toDate: formatedDate.to,
      selectedDateTime:
        moment(date.startDate).format("YYYY-MM-DD " + timeFormat) +
        " - " +
        adjustedEndDate.format("YYYY-MM-DD " + timeFormat),
        ...formatedDate
    });
  };
  handleSearchActionLogs=(event)=>{
    let value=event.target.value
    this.setState({
      searchActionLogs:value
    })
  }
  clearFilter = () => {
    this.setState({
      fromDate: '',
      toDate: '',
      selectedDateTime:'',
      pickerKey: Date.now(),
    });
    
  };

  handleSearchFilter=()=>{
    this.setState({
      searchApi:true,
      laoder:true,
    },()=>{
      this.getActionLogs()
    })
  }
  removeTextData=()=>{
    this.setState({
      searchActionLogs:""
    })
  }

  getAllUsers=()=>{
            fetch(`/api/users/get?userId=${this.props.logInUser?.id}&all=true&page=1&limit=20`)
        .then(response => {
          response.json().then(res=>{
    
            if (res.status === 'success') {
          const allUsers = res.data.data.map(userId => ({
  id: userId.entity?.id,
  value:userId.entity?.id,
  label: userId?.entity?.name,
}));
              this.setState({
                usersIds: allUsers,
              })
              }
              else if(res?.statusCode === '440'){
                window.location.replace('/login')
              }
              else if(res.statusCode){
                var err = res?.message.split(':')
                err[1] =err[1].replace(')', "")
               
                  toast.error(
                  this.props.translate(err[1]),
                )
              }
          })
        })
        .catch(e => {
          toast.error(
             'somethingWentWrong')
        })
    
  }


 searchList = async (inputValue) => {
  if (!inputValue?.trim()) {
    this.setState({ resultMessage: 'No option found' });
    return [];
  }

  try {
    const response = await fetch(
      `/api/users/get?userId=${this.props.logInUser.id}&all=true&page=1&limit=20&search=${encodeURIComponent(inputValue)}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );

    const json = await response.json();
    const users = json?.data?.data || [];

    const result = users.map((item) => ({
      id: item?.entity?.id,
      value: item?.entity?.id,
      label: item?.entity?.name,
    }));

    this.setState({
      resultMessage: result.length === 0 ? 'No option found' : '',
    });

    if (json?.hasNext) {
      result.push({
        value: null,
        isDisabled: true,
        label: 'Search for more.',
      });
    }

    return result;
  } catch (error) {
    console.error('Search error:', error);
    this.setState({ resultMessage: 'Something went wrong' });
    return [];
  }
};

handleChangeUserId=(event,name)=>{
  this.setState({
    userId:name?.value,
    selectedUser:name
  })
}
  
  render () {
    const { tableData } = this.state
    return (
      <Fragment>
        <Grid container className="breadcrumb-row" spacing={1}>
               <Grid item xs={12} sm={1}>
                   <h3 style={{margin: 0}}>{this.props.translate('actionLogs')}</h3>
                </Grid> 
                <Grid item container spacing={1} xs={12} sm={11}  style={{display:'flex',justifyContent:"flex-end"}}> 
                <Grid item xs={12} sm={2}>
                <CustomDateRangePicker
                key={this.state.pickerKey} 
                            actionLogs
                            handleRemoveDate={this.clearFilter}
                            isButtonDisabled={!this.state.selectedDateTime}
                            color={"black"}
                            error={this.props.timeError || false}
                            selectedDate={this.state.selectedDateTime||""}
                            label={
                              this.props.translate('reportFrom') +
                              ' ' +
                              this.props.translate('reportTo')
                            }
                            onEvent={this.showDates}
                          />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <TextField
                          fullWidth
                          value={this.state.searchActionLogs || ''}
                          label={this.props.translate('sharedSearch')}
                          onChange={this.handleSearchActionLogs}
                          InputProps={{
                            endAdornment:this.state.searchActionLogs&& (
                                <InputAdornment
                                    position='end'
                                    disableTypography
                                    style={{ color: "gray" }}
                                >
                      <span style={{color:"gray",marginTop:"0.5rem",cursor:'pointer'}} onClick={this.removeTextData}><Close/></span>
      
                                   
                                </InputAdornment>
                            )
                        }}
                        />
                </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                    id='name'
                    select
                    name="name"
                    value={this.state.itemSearch}
                    onChange={e=>this.handleChangeFilter(e)}
                    margin='dense'
                    fullWidth
                    >  
                    {itemTypes.map(option => (
                        <MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem>
                    ))}
                </TextField> 
            </Grid>
              {this.state.itemSearch && this.state.itemSearch!=='all' && (
                  <Grid item xs={12} sm={2}>
                  <TextField
                      id='name'
                      select
                      name="name"
                      value={this.state?.subType || ''}
                      onChange={e=>this.handleChangeSubType(e)}
                      margin='dense'
                      fullWidth
                      >  
                      {this.state.itemSearch == 1 ?
                          AccountsItem.map(option => (<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) : 
                       this.state.itemSearch == 21 ?
                          AttributesItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 31 ?
                          CalenderItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 41 ?
                          CommandItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 51 ?
                          CouponItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 61 ?
                          DashboardItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 71 ?
                          DevicesItem.map(option => (<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 91 ?
                         DriverItem.map(option => (<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 101 ?
                          EcoDrivingItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 111 ?
                          EventsItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 121 ?
                          GeoFenceItem.map(option => (<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 131 ?
                          ResourcesItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 141 ?
                          ItemGroups.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 151 ?
                          JobsItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 161 ?
                          MaintenanceItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 171 ?
                          NotificationItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 181 ?
                          OrdersItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 191 ?
                          PasswordsItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 201 ?
                          POIItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 211 ?
                          PositionItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                       this.state.itemSearch == 231 ?
                          RolesItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 241 ?
                          ReportTemplatesItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 251 ?
                          SensorsItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 261 ?
                          ServicesItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 271 ?
                          SessionsItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 281 ?
                          TrailersItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 291 ?
                          UsersItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                        this.state.itemSearch == 311 ?
                          VehiclesItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                          this.state.itemSearch == 321 ?
                          LinkUnlinkItems.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                          this.state.itemSearch == 501 ?
                          GarageItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                          this.state.itemSearch == 526 ?
                          ExpenseTypeItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                          this.state.itemSearch == 541 ?
                          ExpenseSubTypeItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                          this.state.itemSearch == 551 ?
                          AreaItem.map(option =>(<MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem> )) :
                          null
                      }
                      {/* {itemTypes.map(option => (
                          <MenuItem value={option.key}> {this.props.translate(option.name)}</MenuItem>
                      ))} */}
                  </TextField> 
                </Grid>
                )}
                     <Grid item xs={12} sm={2}>

<AsyncSelect
  isMulti={false}
  value={this.state.selectedUser}
  selectName="userId"
  isClearable
  placeholder={this.props.translate("searchUsers")}
  resultMessage={this.state.resultMessage}
  defaultOptions={this.state.usersIds}
  handleChange={this.handleChangeUserId}
  loadOptions={this.searchList}
/>
                          </Grid>
            <Grid item xs={12} sm={2} style={{display:"flex",gap:"0.5rem",justifyContent:"flex-end"}}>
                                  <Button
                                     onClick={this.handleSearchFilter} 
                                    variant="contained"
                                    color="secondary"
                                   >
                                    {this.props.translate("search")}
                                  </Button>
                                <ExportFile
                                title={this.props.translate("export")}
                                fileName="actionLogs"
                                downloadType="actionLogs"
                                translate={this.props.translate}
                                dataLength={
                                    tableData && tableData?.length ? true : false

                                }
                                closedModel={this.onCloseC_Modal}
                                dispatch={this.props.dispatch}
                                />
            </Grid>
            </Grid>
        

        </Grid>

        {tableData.length > 0 && !this.state.loader ?  (
          <Table
            rows={tableData}
            rowsPerPage={10}
            themecolors={this.props.themecolors}
            pagination={this.setPagination(this.state.pagData)}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleChangePage={this.handleChangePage}
            setSerialNo
            logInUser={this.props.logInUser}
            translate={this.props.translate}
            rowDefinition={[
                           {
                id: 'attributes.userName',
                numeric: false,
                disablePadding: false,
                label: this.props.translate('userName')
              },
              {
                id: 'actionDetails',
                numeric: false,
                disablePadding: false,
                label: this.props.translate('actionDetails')
              },
              {
                id: 'actionTime',
                numeric: false,
                disablePadding: false,
                label: this.props.translate('actionTime')
               },
               {
                id: 'os',
                numeric: false,
                disablePadding: false,
                label: this.props.translate('Operating  System')
               },
               {
                id: 'browser',
                numeric: false,
                disablePadding: false,
                label: this.props.translate('Browser')
               },
              // {
              //   id: 'host',
              //   numeric: false,
              //   disablePadding: false,
              //   label: this.props.translate('host')
              // },
              // {
              //   id: 'ipAddress',
              //   numeric: false,
              //   disablePadding: false,
              //   label: this.props.translate('ipAddress')
              // },
            ]}
          />
        ): 
        this.state.loader ? <Loader /> :
        <h1>No Record Found</h1>
    }
        </Fragment>
    )
  }
}

const mapState = state => ({
  reports: state.reports,
  themecolors: state.themecolors,
  logInUser:state.logInUsers
})
const mapStateToProps = connect(mapState)
export const ShowLogs = mapStateToProps((showLogs))
